'use client'
import Link from 'next/link'
import { redirect, usePathname, useSearchParams } from 'next/navigation'
import { generatePaginationNumbers } from '@/utils'
import { IoChevronBackOutline, IoChevronForwardOutline } from 'react-icons/io5'
import { useProductStore } from '@/store'
import { useEffect } from 'react'
import { checkPaginationRoutes } from '@/utils/CheckPaginationRoute'

interface Props {
  totalPages: number
  totalResult: number
}

export const Pagination = ({ totalPages, totalResult }: Props) => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const setTotalResult = useProductStore((state) => state.setTotalResult)

  useEffect(() => {
    checkPaginationRoutes({ pathname })
  }, [pathname])

  useEffect(() => {
    setTotalResult(totalResult)
  }, [totalResult])

  const pageString = searchParams.get('page') ?? 1
  const currentPage = isNaN(+pageString) ? 1 : +pageString

  if (currentPage < 1 || isNaN(+pageString)) {
    redirect(pathname)
  }

  const allPages = generatePaginationNumbers(currentPage, totalPages)

  const createPageUrl = (pageNumber: number | string) => {
    const params = new URLSearchParams(searchParams)

    if (pageNumber === '...') {
      return `${pathname}?${params.toString()}`
    }

    if (+pageNumber <= 0) {
      return `${pathname}` //   href="/kid";
    }

    if (+pageNumber > totalPages) {
      // Next >
      return `${pathname}?${params.toString()}`
    }

    params.set('page', pageNumber.toString())
    return `${pathname}?${params.toString()}`
  }

  return (
    <>
      {totalResult > 0 ? (
        <div className="flex text-center justify-center mt-10 mb-20">
          <nav aria-label="Page navigation">
            <ul className="flex list-style-none">
              <li className="page-item">
                <Link
                  className="page-link relative block py-1.5 px-3 border-0 bg-transparent outline-none transition-all duration-300 rounded text-gray-800 hover:text-gray-800 hover:bg-gray-200 focus:shadow-none"
                  href={createPageUrl(currentPage - 1)}
                >
                  <IoChevronBackOutline size={30} />
                </Link>
              </li>

              {allPages.map((page, index) => (
                <li key={`${page}-${index + 1}`} className="page-item">
                  <Link
                    className={
                      `page-link relative block py-1.5 px-3 border-0 outline-none transition-all duration-300 
                    rounded text-gray-800 hover:text-gray-800 hover:bg-gray-200 focus:shadow-none` +
                      (page === currentPage
                        ? ' bg-blue-600 shadow-sm text-white hover:text-white hover:bg-blue-700'
                        : '')
                    }
                    href={createPageUrl(page)}
                  >
                    {page}
                  </Link>
                </li>
              ))}

              <li className="page-item">
                <Link
                  className="page-link relative block py-1.5 px-3 border-0 bg-transparent outline-none transition-all duration-300 rounded text-gray-800 hover:text-gray-800 hover:bg-gray-200 focus:shadow-none"
                  href={createPageUrl(currentPage + 1)}
                >
                  <IoChevronForwardOutline size={30} />
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      ) : (
        <></>
      )}
    </>
  )
}
